import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { join, isString, isEmpty, split, filter } from "lodash";
import { withRouter } from "react-router";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@mui/material";
// import DashboardIcon from "@mui/icons-material/Dashboard";
import LabelIcon from "@mui/icons-material/Label";
import NotificationsActive from "@mui/icons-material/Notifications";
import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import InfoIcon from "@mui/icons-material/Info";
import { Link } from "react-router-dom";
import { urlResource } from "common/utils";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

export const QuickLink = (props) => (
  <SvgIcon {...props}>
    <path
      d="M19.5735 14.4266C18.2083 13.062 16.357 12.2954 14.4268 12.2954C12.4965 12.2954 10.6453 13.062 9.28013 14.4266L4.1318 19.5733C2.7666 20.9385 1.99963 22.7901 1.99963 24.7208C1.99963 26.6515 2.7666 28.5031 4.1318 29.8683C5.497 31.2335 7.34861 32.0004 9.2793 32.0004C11.21 32.0004 13.0616 31.2335 14.4268 29.8683L17.0001 27.2949"
      stroke="#0000008a"
      strokeWidth="3.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.4268 19.5733C15.7919 20.938 17.6432 21.7045 19.5734 21.7045C21.5037 21.7045 23.3549 20.938 24.7201 19.5733L29.8684 14.4267C31.2336 13.0615 32.0006 11.2099 32.0006 9.27918C32.0006 7.34849 31.2336 5.49688 29.8684 4.13168C28.5032 2.76647 26.6516 1.99951 24.7209 1.99951C22.7902 1.99951 20.9386 2.76647 19.5734 4.13168L17.0001 6.70501"
      stroke="#0000008a"
      strokeWidth="3.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export const Help = (props) => (
  <SvgIcon {...props}>
    <path d="M22.1167 15.7499L20.6167 17.2833C19.4167 18.4833 18.6667 19.4999 18.6667 21.9999H15.3334V21.1666C15.3334 19.3166 16.0834 17.6499 17.2834 16.4499L19.35 14.3499C19.9667 13.7499 20.3334 12.9166 20.3334 11.9999C20.3334 11.1159 19.9822 10.268 19.3571 9.6429C18.7319 9.01777 17.8841 8.66658 17 8.66658C16.116 8.66658 15.2681 9.01777 14.643 9.6429C14.0179 10.268 13.6667 11.1159 13.6667 11.9999H10.3334C10.3334 10.2318 11.0358 8.53612 12.286 7.28587C13.5362 6.03563 15.2319 5.33325 17 5.33325C18.7682 5.33325 20.4638 6.03563 21.7141 7.28587C22.9643 8.53612 23.6667 10.2318 23.6667 11.9999C23.6643 13.4053 23.1073 14.753 22.1167 15.7499ZM18.6667 28.6666H15.3334V25.3333H18.6667V28.6666ZM17 0.333252C14.8113 0.333252 12.6441 0.764348 10.622 1.60193C8.59989 2.4395 6.76257 3.66716 5.21493 5.21481C2.08932 8.34041 0.333374 12.5796 0.333374 16.9999C0.333374 21.4202 2.08932 25.6594 5.21493 28.785C6.76257 30.3327 8.59989 31.5603 10.622 32.3979C12.6441 33.2355 14.8113 33.6666 17 33.6666C21.4203 33.6666 25.6595 31.9106 28.7852 28.785C31.9108 25.6594 33.6667 21.4202 33.6667 16.9999C33.6667 7.78325 26.1667 0.333252 17 0.333252Z" />
  </SvgIcon>
);

const getBaseUrl = (location) => {
  let pathnameComponents = split(location.pathname, "/", 3);
  let processedComponents = filter(
    pathnameComponents,
    (value) => isString(value) && !isEmpty(value),
  );
  let baseUrl = `/${join(processedComponents, "/")}`;
  return baseUrl;
};

const AdminNavLinks = ({ location, permissions, resource, classes }) => {
  const { t } = useTranslation();
  return (
    <List component="nav">
      {resource.singular === "building" ? (
        <ListItemButton
          component={Link}
          to={`${getBaseUrl(location)}/notifications`}
        >
          <ListItemIcon>
            <NotificationsActive />
          </ListItemIcon>
          <ListItemText primary={t("side_menu.updates")} />
        </ListItemButton>
      ) : null}
      <ListItemButton component={Link} to={`${getBaseUrl(location)}/offers`}>
        <ListItemIcon>
          <LabelIcon />
        </ListItemIcon>
        <ListItemText primary={t("side_menu.reward_offers")} />
      </ListItemButton>
      {resource.singular === "building" ? (
        <ListItemButton
          component={Link}
          to={`${getBaseUrl(location)}/quick_links`}
        >
          <ListItemIcon>
            <QuickLink viewBox="0 0 34 34" />
          </ListItemIcon>
          <ListItemText primary={t("side_menu.quick_links")} />
        </ListItemButton>
      ) : null}
      {resource.singular === "building" ? (
        <ListItemButton
          component={Link}
          to={`${getBaseUrl(location)}/services`}
        >
          <ListItemIcon>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary={t("side_menu.services")} />
        </ListItemButton>
      ) : null}
      {resource.singular === "building" ? (
        <ListItemButton
          component={Link}
          to={`${getBaseUrl(location)}/contact_topics`}
        >
          <ListItemIcon>
            <QuestionAnswer />
          </ListItemIcon>
          <ListItemText primary={t("side_menu.contact_topics")} />
        </ListItemButton>
      ) : null}
      <ListItemButton
        component="a"
        href="https://www.hiloapp.com/help"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ListItemIcon>
          <Help viewBox="0 0 34 34" />
        </ListItemIcon>
        <ListItemText primary={t("side_menu.help")} />
      </ListItemButton>
    </List>
  );
};

const mapStateToProps = ({ auth }, { location }) => {
  return {
    permissions: auth.permissions,
    resource: urlResource(location.pathname),
  };
};

AdminNavLinks.propTypes = {
  location: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
  }).isRequired,
};

const styles = (theme) => ({
  selected: {
    backgroundColor: theme.palette.action.selected,
  },
});

const enhanced = compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps),
);

export default enhanced(AdminNavLinks);
